var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrameWh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.538172C0 0.240948 0.240948 0 0.538172 0H69.4618C69.7591 0 70 0.240948 70 0.538172V69.4618C70 69.7591 69.7591 70 69.4618 70H0.538172C0.240948 70 0 69.7591 0 69.4618V0.538172ZM1.07634 1.07634V68.9237H68.9237V1.07634H1.07634Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.98926 6.52841C5.98926 6.23118 6.23021 5.99023 6.52743 5.99023H63.466C63.7632 5.99023 64.0042 6.23118 64.0042 6.52841V63.467C64.0042 63.7642 63.7632 64.0052 63.466 64.0052H6.52743C6.23021 64.0052 5.98926 63.7642 5.98926 63.467V6.52841ZM7.0656 7.06658V62.9288H62.9278V7.06658H7.0656Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52891 52.7129H0.539062V69.4608H6.52891V52.7129Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2871 69.4566V63.4668H0.539207V69.4566H17.2871Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4711 17.2871H69.4609V0.539206H63.4711V17.2871Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7129 0.537495V6.52734L69.4608 6.52734V0.537495L52.7129 0.537495Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameWh);
export default __webpack_public_path__ + "static/media/Frame-wh.9608f8d5b2f89bac6fb3fd160a7d5653.svg";
export { ForwardRef as ReactComponent };